import RightArrow from '@/public/icons/record/rightArrow.svg';
import LeftArrow from '@/public/icons/record/leftArrow.svg';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import usePlatform from '@/components/Record/hooks/usePlatform';

type Props = {
  weekOffset: number;
  handleNextWeek(): void;
  handlePrevWeek(): void;
  handleThisWeek(): void;
};

const ButtonList = ({
  weekOffset,
  handlePrevWeek,
  handleNextWeek,
  handleThisWeek,
}: Props) => {
  const { t } = useTranslation();
  const { isMobilePath } = usePlatform();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: isMobilePath ? '16px 0 ' : '',
      }}
    >
      <StyledButton onClick={handlePrevWeek}>
        <LeftArrow />
      </StyledButton>
      <StyledCenterButton disabled={weekOffset === 0} onClick={handleThisWeek}>
        {t('이번주로 돌아가기')}
      </StyledCenterButton>
      <StyledButton onClick={handleNextWeek}>
        <RightArrow />
      </StyledButton>
    </div>
  );
};

export default ButtonList;

const StyledCenterButton = styled.button`
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  display: flex;
  padding: 6px 8px;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  :disabled {
    background-color: var(--dk-bg-subtle, #f9fafb);
    color: var(--dk-text-disabled, #d1d8e2);
  }
`;

const StyledButton = styled.button`
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);

  box-sizing: content-box;
  > svg {
    vertical-align: middle;
  }
`;
